import React from 'react';
import { useIntl } from 'react-intl';

import AddOnBoardingScreens from '../../../components/SiteAdmin/ManageProviderOnBoardingScreens/AddOnBoardingScreens';

import messages from '../../../locale/messages';

const AddScreen = ({ }) => {
    const { formatMessage } = useIntl();

    return (
        <div>
            <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.addProviderOnBoardingScreens)}</h1>
            <AddOnBoardingScreens />
        </div>
    );
}

export default AddScreen;
